var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneReadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.9998H4.99984L1.6665 18.3332V3.33317C1.6665 2.4165 2.4165 1.6665 3.33317 1.6665H16.6665C17.5832 1.6665 18.3332 2.4165 18.3332 3.33317V9.1665H16.6665V3.33317H3.33317V13.3332H9.99984V14.9998ZM19.1665 11.9498L17.9915 10.7748L14.4582 14.3082L12.6915 12.5415L11.5165 13.7165L14.4498 16.6665L19.1665 11.9498Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneReadIcon);
export default __webpack_public_path__ + "static/media/Done-Read-Icon.d2cf93392abab9dda20747808bc06394.svg";
export { ForwardRef as ReactComponent };